import { DataGrid } from '@mui/x-data-grid';
import axios from 'axios';
import { xapi } from '../../hooks/session';
import { IUser } from '../../models/user';
import { throwError } from '../helper';

/*
 * User
 */

export const getUserList = (
  page: number,
  rowsPerPage: number,
  searchKey: string,
  searchWord: string
) =>
  xapi
    .get(
      `/admin/v1/apis/user/users?page=${page}&perPage=${rowsPerPage}&searchKey=${searchKey}&searchWord=${searchWord}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getUserDetailInfo = (id: string) =>
  xapi.get(`/admin/v1/apis/user/${id}/detail`).then(res => {
    if (res.status !== 200) throwError(res.status);
    return res.data;
  });

export const patchUserDelete = (data: any) =>
  xapi.put(`/admin/v1/apis/user/${data.id}/delete`, data).then(res => {
    if (res.status !== 200) throwError(res.status);
    return res.data;
  });

export const patchUserInfo = (data: any) =>
  xapi.put(`/admin/v1/apis/user/${data.id}/info`, data);

export const downloadUserList = (searchKey: string, searchWord: string) =>
  xapi
    .get(
      `/admin/v1/apis/user/download/users?searchKey=${searchKey}&searchWord=${searchWord}`,
      { responseType: 'blob' }
    )
    .then(res => {
      const blob = new Blob([res.data]);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'user.xlsx';
      document.body.appendChild(a);
      a.click();
      setTimeout((_: any) => {
        window.URL.revokeObjectURL(url);
      }, 60000);
      a.remove();
    })
    .catch(err => {
      console.error('err: ', err);
    });

/*
 * Read / Write / Step
 */
export const getUserReadList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/user/${data.seq}/read-status/${data.type}?page=${data.page}&perPage=${data.rowsPerPage}&searchKey=${data.searchKey}&searchWord=${data.searchWord}&startDate=${data.startDate}&endDate=${data.endDate}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getUserWriteList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/user/${data.seq}/write-status?page=${data.page}&perPage=${data.rowsPerPage}&searchKey=${data.searchKey}&searchWord=${data.searchWord}&startDate=${data.startDate}&endDate=${data.endDate}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getUserStepList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/user/${data.seq}/step-status?page=${data.page}&perPage=${data.rowsPerPage}&searchKey=${data.searchKey}&searchWord=${data.searchWord}&startDate=${data.startDate}&endDate=${data.endDate}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getUserWriteStatList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/user/${data.seq}/write-day-stat?page=${data.page}&perPage=${data.rowsPerPage}&searchKey=${data.searchKey}&searchWord=${data.searchWord}&startDate=${data.startDate}&endDate=${data.endDate}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });
